const today   = new Date();
const fmt     = (d) => d.toISOString().split('T')[0];

export const D_START = fmt(new Date(today.getFullYear(), today.getMonth(), today.getDate() - 15));
export const D_END   = fmt(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 15));

export const norm = (c) => ({
	generation:   c.Generation   ?? c.generation   ?? '',
	manufacturer: c.Manufacturer ?? c.manufacturer ?? '',
	omcId:        c.OmcId        ?? c.omcId        ?? c.OMC_ID ?? '',
	tac:          c.Tac          ?? c.tac          ?? '',
});

export const uniq = (arr) => [...new Set(arr)].filter(Boolean).sort();

export const cascade = (rawCombos, techs, vendors, servers) => {
	const combos   = rawCombos.map(norm);
	const byTech   = techs.length   ? combos.filter((c) => techs.includes(c.generation))      : combos;
	const byVendor = vendors.length ? byTech.filter((c)  => vendors.includes(c.manufacturer)) : byTech;
	const byServer = servers.length ? byVendor.filter((c) => servers.includes(c.omcId))       : byVendor;
	return {
		availTechs:   uniq(combos.map((c)   => c.generation)),
		availVendors: uniq(byTech.map((c)   => c.manufacturer)),
		availServers: uniq(byVendor.map((c) => c.omcId)),
		availTacs:    uniq(byServer.map((c) => c.tac)),
	};
};